<template>
	<div class="desktop-layout__bottom">
		<div class="desktop-layout__footer">
			<div class="desktop-layout__footer__top">
				<logo class="desktop-layout__footer__top__logo" />
				<div class="desktop-layout__footer__column">
					<h3 class="desktop-layout__footer__column__title">
						{{ $t("general.learn-more") }}
					</h3>
					<ul class="desktop-layout__footer__column__links">
						<li
							class="desktop-layout__footer__column__links__item"
							v-if="env.helpLink && !isKenya"
						>
							<a
								:href="`${env.helpLink}`"
								target="_blank"
								class="desktop-layout__footer__column__link"
								>{{ $t("general.help-center") }}</a
							>
						</li>

						<li class="desktop-layout__footer__column__links__item">
							<a
								class="desktop-layout__footer__column__link"
								:href="env.termsLink"
								target="_blank"
								v-if="env.termsLinkType == 'external'"
							>
								{{ $t("legal.terms-conditions") }}
							</a>
							<router-link
								v-else
								class="desktop-layout__footer__column__link"
								:to="env.termsLink"
							>
								{{ $t("legal.terms-conditions") }}
							</router-link>
						</li>
						<li
							class="desktop-layout__footer__column__links__item"
							v-if="env.responsibleGaming.link"
						>
						<a
							v-if="env.responsibleGaming.linkType == 'external'"
								class="desktop-layout__footer__column__link"
								:href="env.responsibleGaming.link"
								target="_blank"
							>
								{{ $t("legal.responsible-gaming-policy") }}
							</a>
							<router-link
								v-else
								class="desktop-layout__footer__column__link"
								:to="env.responsibleGaming.link"
							>
							{{ $t("legal.responsible-gaming-policy") }}
							</router-link>
						</li>
						<li
							class="desktop-layout__footer__column__links__item"
							v-if="env.privacyPolicyLink.link"
						>
							<a
							v-if="env.privacyPolicyLink.linkType == 'external'"
								class="desktop-layout__footer__column__link"
								:href="env.privacyPolicyLink.link"
								target="_blank"
							>
								{{ $t("legal.privacy-policy.key") }}
							</a>
							<router-link
								v-else
								class="desktop-layout__footer__column__link"
								:to="env.privacyPolicyLink.link"
							>
							{{ $t("legal.privacy-policy.key") }}
							</router-link>
						</li>
						<li
							class="desktop-layout__footer__column__links__item"
							v-if="env.sportBettingRules.link"
						>
							<a
							v-if="env.sportBettingRules.linkType == 'external'"
								class="desktop-layout__footer__column__link"
								:href="env.sportBettingRules.link"
								target="_blank"
							>
								{{ $t("legal.sports-betting-rules") }}
							</a>
							<router-link
								v-else
								class="desktop-layout__footer__column__link"
								:to="env.sportBettingRules.link"
							>
							{{ $t("legal.sports-betting-rules") }}
							</router-link>
						</li>
					</ul>
				</div>
				<div v-if="env.liteInformation.link" class="desktop-layout__footer__column">
					<h3 class="desktop-layout__footer__column__title">
						{{ $t("general.lite-version") }}
					</h3>
					<ul class="desktop-layout__footer__column__links">
						<li class="desktop-layout__footer__column__links__item">
							<a v-if="env.liteInformation.link" :href="env.liteInformation.link" target="_blank" class="desktop-layout__footer__column__link">
						{{ $t("general.betika-lite") }}
					</a>
					</li>
					<li class="desktop-layout__footer__column__links__item">
						<router-link
						v-if="env.liteInformation.ussdBettingDocumentLink"
								class="desktop-layout__footer__column__link"
								:to="env.liteInformation.ussdBettingDocumentLink"
							>
							{{ $t("general.ussd-betting") }}
							</router-link>
					</li>
					</ul>
					
						
						<!-- <a v-if="env.liteInformation.ussdBettingDocumentLink" :href="env.liteInformation.ussdBettingDocumentLink" class="desktop-layout__footer__column__link">
						{{ $t("general.ussd-betting") }}
					</a> -->
					
				</div>
				<div class="desktop-layout__footer__column">
					<h3 class="desktop-layout__footer__column__title">
						{{ $t("footer.play") }}
					</h3>
					<ul class="desktop-layout__footer__column__links">
						<li class="desktop-layout__footer__column__links__item">
							<router-link
								to="/"
								class="desktop-layout__footer__column__link"
								>{{ $t("footer.sports") }}</router-link
							>
						</li>
						<li
							class="desktop-layout__footer__column__links__item"
							v-if="env.availableProducts.includes('jackpots')"
						>
							<router-link
								:to="{ name: 'boosted-multibet-events' }"
								class="desktop-layout__footer__column__link"
								>{{ $t("nav.jackpots") }}</router-link
							>
						</li>
						<li
							class="desktop-layout__footer__column__links__item"
							v-if="env.availableProducts.includes('virtualHub')"
						>
							<router-link
								:to="{ name: 'virtuals' }"
								class="desktop-layout__footer__column__link"
								>{{ $t("nav.virtuals") }}</router-link
							>
						</li>
						<li
							class="desktop-layout__footer__column__links__item"
							v-if="env.availableProducts.includes('virtuals')"
						>
							<router-link
								:to="{ name: 'virtual' }"
								class="desktop-layout__footer__column__link"
								>{{ $t("nav.virtuals") }}</router-link
							>
						</li>
						<li
							class="desktop-layout__footer__column__links__item"
							v-if="env.availableProducts.includes('casino')"
						>
							<router-link
								:to="{ name: 'casino' }"
								class="desktop-layout__footer__column__link"
								>{{ $t("nav.casino") }}</router-link
							>
						</li>
					</ul>
				</div>
				<div class="desktop-layout__footer__column">
					<h3 class="desktop-layout__footer__column__title">
						{{ $t("footer.contact-us") }}
					</h3>
					<div class="desktop-layout__footer__contacts">


						<div v-if="env.whatsappInformation.link" :class="env.useContactUsIcons  ? 'desktop-layout__footer__contact-with-icon' : 'desktop-layout__footer__contact'">
							<svg class="desktop-layout__footer__contact-icon" v-if="env.useContactUsIcons" fill="#fff" width="20px" height="20px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin"><path d='M9.516.012C4.206.262.017 4.652.033 9.929a9.798 9.798 0 0 0 1.085 4.465L.06 19.495a.387.387 0 0 0 .47.453l5.034-1.184a9.981 9.981 0 0 0 4.284 1.032c5.427.083 9.951-4.195 10.12-9.58C20.15 4.441 15.351-.265 9.516.011zm6.007 15.367a7.784 7.784 0 0 1-5.52 2.27 7.77 7.77 0 0 1-3.474-.808l-.701-.347-3.087.726.65-3.131-.346-.672A7.62 7.62 0 0 1 2.197 9.9c0-2.07.812-4.017 2.286-5.48a7.85 7.85 0 0 1 5.52-2.271c2.086 0 4.046.806 5.52 2.27a7.672 7.672 0 0 1 2.287 5.48c0 2.052-.825 4.03-2.287 5.481z'/><path d='M14.842 12.045l-1.931-.55a.723.723 0 0 0-.713.186l-.472.478a.707.707 0 0 1-.765.16c-.913-.367-2.835-2.063-3.326-2.912a.694.694 0 0 1 .056-.774l.412-.53a.71.71 0 0 0 .089-.726L7.38 5.553a.723.723 0 0 0-1.125-.256c-.539.453-1.179 1.14-1.256 1.903-.137 1.343.443 3.036 2.637 5.07 2.535 2.349 4.566 2.66 5.887 2.341.75-.18 1.35-.903 1.727-1.494a.713.713 0 0 0-.408-1.072z'/></svg>
							<h4 v-else class="desktop-layout__footer__contact__label">
								{{ $t("footer.whatsapp") }}
							</h4>
							<a
								class="desktop-layout__footer__contact__value"
								:href="env.whatsappInformation.link"
								target="_blank"
								>{{ env.whatsappInformation.number }}</a
							>
						</div>
						
						<div :class="env.useContactUsIcons  ? 'desktop-layout__footer__contact-with-icon' : 'desktop-layout__footer__contact'">
							<svg class="desktop-layout__footer__contact-icon" v-if="env.useContactUsIcons" fill="#fff" width="20px" height="20px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin">
								<path id="primary" d="M21,15v3.93a2,2,0,0,1-2.29,2A18,18,0,0,1,3.14,5.29,2,2,0,0,1,5.13,3H9a1,1,0,0,1,1,.89,10.74,10.74,0,0,0,1,3.78,1,1,0,0,1-.42,1.26l-.86.49a1,1,0,0,0-.33,1.46,14.08,14.08,0,0,0,3.69,3.69,1,1,0,0,0,1.46-.33l.49-.86A1,1,0,0,1,16.33,13a10.74,10.74,0,0,0,3.78,1A1,1,0,0,1,21,15Z" style="fill: #fff; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></path>							</svg>
							<h4 v-else class="desktop-layout__footer__contact__label">
								{{ $t("footer.telephone") }}
							</h4>
							<a
								v-if="env.supportNumberList.length > 0"
								v-for="(supportNumber, idx) in env.supportNumberList" :key="idx"
								class="desktop-layout__footer__contact__value"
								:href="`tel:${supportNumber.number}`"
								target="_blank"
								>
									<div class="desktop-layout__footer__contact__value--contact"><span>{{ supportNumber.provider }}:</span> {{ supportNumber.number }}</div>
								</a
							>
							<a
								v-if="env.supportNumberList.length == 0"
								class="desktop-layout__footer__contact__value"
								:href="`tel:${env.supportNumber}`"
								target="_blank"
								>
									<div class="desktop-layout__footer__contact__value">{{env.supportNumber}}</div>
								</a
							>
							<p class="desktop-layout__footer__contact__value--contact-availability" v-if="env.supportAvailabilityTime">{{ env.supportAvailabilityTime }}</p>
						</div>
						<div :class="env.useContactUsIcons  ? 'desktop-layout__footer__contact-with-icon' : 'desktop-layout__footer__contact'">
							<svg class="desktop-layout__footer__contact-icon" v-if="env.useContactUsIcons" width="20px" height="20px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g id="icomoon-ignore">
</g>
<path d="M28.244 7.47h-25.572v17.060h26.656v-17.060h-1.084zM27.177 8.536l-10.298 10.298c-0.47 0.47-1.289 0.47-1.759 0l-10.3-10.298h22.356zM3.738 8.961l6.923 6.922-6.923 6.923v-13.846zM4.589 23.464l6.827-6.826 2.951 2.95c0.436 0.436 1.016 0.677 1.633 0.677s1.197-0.241 1.633-0.677l2.951-2.951 6.826 6.826h-22.822zM28.262 22.807l-6.923-6.924 6.923-6.924v13.848z" fill="#fff">

</path>
</svg>							
<h4 v-else class="desktop-layout__footer__contact__label">
								{{ $t("footer.email") }}
							</h4>
							<a
								class="desktop-layout__footer__contact__value"
								:href="emailLink"
								target="_blank"
								>{{ env.supportEmail }}</a
							>
						</div>
					</div>
				</div>
			</div>
			<hr class="desktop-layout__footer__divider" />
			<div class="desktop-layout__footer__bottom">
				<div class="desktop-layout__footer__bottom__item">
					<h4 class="desktop-layout__footer__bottom__item__label">
						{{ $t("footer.license") }}
					</h4>
					<p class="desktop-layout__footer__bottom__item__value">
						{{ env.licenseDescription }}
					</p>

					<div v-if="env.regulatorLogo !== ''">
						<div class="desktop-layout__footer__bottom__item__value__regulator">
							<p class="desktop-layout__footer__bottom__item__regulator">
								{{ $t("overlay-menu.regulated-by") }}
							</p>
							<div class="desktop-layout__bottom__desc__socials">
								<img
									class="desktop-layout__bottom__desc__socials__logo"
									:src="env.regulatorLogo"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="desktop-layout__footer__bottom__item">
					<h4 class="desktop-layout__footer__bottom__item__label">{{env.kyc.legalAgeLimit}}+</h4>
					<p class="desktop-layout__footer__bottom__item__value">
						{{ $t("footer.age-limit") }}
					</p>
				</div>
			</div>
		</div>
		<hr class="desktop-layout__bottom__divider" />
		<div class="desktop-layout__bottom__desc">
			<p class="desktop-layout__bottom__desc__copyright">
				© {{ new Date().getFullYear() }} Betika.com |
				{{ $t("footer.copyright") }}
			</p>
			<div class="desktop-layout__bottom__desc__socials" v-if="env.socialUrls">
				<a
					v-if="env.socialUrls.facebook"
					:href="env.socialUrls.facebook"
					target="_black"
					class="desktop-layout__bottom__desc__socials__link"
				>
					<svg
						width="16"
						height="17"
						viewBox="0 0 16 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						class="desktop-layout__bottom__desc__socials__icon"
					>
						<path
							d="M15.875 1.25391C15.875 1.00781 15.7695 0.796875 15.5938 0.621094C15.418 0.480469 15.207 0.375 14.9961 0.375H1.00391C0.722656 0.375 0.511719 0.480469 0.371094 0.621094C0.195312 0.796875 0.125 1.00781 0.125 1.25391V15.2461C0.125 15.4922 0.195312 15.7031 0.371094 15.8789C0.511719 16.0547 0.722656 16.125 1.00391 16.125H8.52734V10.0078H6.48828V7.65234H8.52734V5.89453C8.52734 4.91016 8.80859 4.13672 9.37109 3.57422C9.93359 3.04688 10.6719 2.76562 11.5859 2.76562C12.2891 2.76562 12.9219 2.80078 13.4141 2.83594V4.98047H12.1484C11.6914 4.98047 11.375 5.08594 11.1992 5.29688C11.0586 5.47266 10.9883 5.75391 10.9883 6.14062V7.65234H13.3438L13.0273 10.0078H10.9883V16.125H14.9961C15.2422 16.125 15.4531 16.0547 15.6289 15.8789C15.7695 15.7031 15.875 15.4922 15.875 15.2461V1.25391Z"
						/>
					</svg>
				</a>
				<a
					v-if="env.socialUrls.instagram"
					:href="env.socialUrls.instagram"
					target="_black"
					class="desktop-layout__bottom__desc__socials__link"
				>
					<svg
						width="16"
						height="17"
						viewBox="0 0 16 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						class="desktop-layout__bottom__desc__socials__icon"
					>
						<path
							d="M8 4.20703C8.70312 4.20703 9.37109 4.41797 10.0039 4.76953C10.6367 5.12109 11.1289 5.61328 11.4805 6.24609C11.832 6.87891 12.043 7.54688 12.043 8.25C12.043 8.98828 11.832 9.65625 11.4805 10.2891C11.1289 10.9219 10.6367 11.4141 10.0039 11.7656C9.37109 12.1172 8.70312 12.293 8 12.293C7.26172 12.293 6.59375 12.1172 5.96094 11.7656C5.32812 11.4141 4.83594 10.9219 4.48438 10.2891C4.13281 9.65625 3.95703 8.98828 3.95703 8.25C3.95703 7.54688 4.13281 6.87891 4.48438 6.24609C4.83594 5.61328 5.32812 5.12109 5.96094 4.76953C6.59375 4.41797 7.26172 4.20703 8 4.20703ZM8 10.8867C8.70312 10.8867 9.33594 10.6406 9.86328 10.1133C10.3555 9.62109 10.6367 8.98828 10.6367 8.25C10.6367 7.54688 10.3555 6.91406 9.86328 6.38672C9.33594 5.89453 8.70312 5.61328 8 5.61328C7.26172 5.61328 6.62891 5.89453 6.13672 6.38672C5.60938 6.91406 5.36328 7.54688 5.36328 8.25C5.36328 8.98828 5.60938 9.62109 6.13672 10.1133C6.62891 10.6406 7.26172 10.8867 8 10.8867ZM13.168 4.03125C13.168 3.78516 13.0625 3.57422 12.8867 3.36328C12.6758 3.1875 12.4648 3.08203 12.2188 3.08203C11.9375 3.08203 11.7266 3.1875 11.5508 3.36328C11.3398 3.57422 11.2695 3.78516 11.2695 4.03125C11.2695 4.3125 11.3398 4.52344 11.5508 4.69922C11.7266 4.91016 11.9375 4.98047 12.2188 4.98047C12.4648 4.98047 12.6758 4.91016 12.8516 4.69922C13.0273 4.52344 13.1328 4.3125 13.168 4.03125ZM15.8398 4.98047C15.8398 5.64844 15.875 6.73828 15.875 8.25C15.875 9.79688 15.8398 10.8867 15.8047 11.5547C15.7695 12.2227 15.6641 12.7852 15.5234 13.2773C15.3125 13.875 14.9609 14.4023 14.5391 14.8242C14.1172 15.2461 13.5898 15.5625 13.0273 15.7734C12.5352 15.9492 11.9375 16.0547 11.2695 16.0898C10.6016 16.125 9.51172 16.125 8 16.125C6.45312 16.125 5.36328 16.125 4.69531 16.0898C4.02734 16.0547 3.46484 15.9492 2.97266 15.7383C2.375 15.5625 1.84766 15.2461 1.42578 14.8242C1.00391 14.4023 0.6875 13.875 0.476562 13.2773C0.300781 12.7852 0.195312 12.2227 0.160156 11.5547C0.125 10.8867 0.125 9.79688 0.125 8.25C0.125 6.73828 0.125 5.64844 0.160156 4.98047C0.195312 4.3125 0.300781 3.71484 0.476562 3.22266C0.6875 2.66016 1.00391 2.13281 1.42578 1.71094C1.84766 1.28906 2.375 0.9375 2.97266 0.726562C3.46484 0.585938 4.02734 0.480469 4.69531 0.445312C5.36328 0.410156 6.45312 0.375 8 0.375C9.51172 0.375 10.6016 0.410156 11.2695 0.445312C11.9375 0.480469 12.5352 0.585938 13.0273 0.726562C13.5898 0.9375 14.1172 1.28906 14.5391 1.71094C14.9609 2.13281 15.3125 2.66016 15.5234 3.22266C15.6641 3.71484 15.7695 4.3125 15.8398 4.98047ZM14.1523 12.8906C14.293 12.5039 14.3633 11.8711 14.4336 10.9922C14.4336 10.5 14.4688 9.76172 14.4688 8.8125V7.6875C14.4688 6.73828 14.4336 6 14.4336 5.50781C14.3633 4.62891 14.293 3.99609 14.1523 3.60938C13.8711 2.90625 13.3438 2.37891 12.6406 2.09766C12.2539 1.95703 11.6211 1.88672 10.7422 1.81641C10.2148 1.81641 9.47656 1.78125 8.5625 1.78125H7.4375C6.48828 1.78125 5.75 1.81641 5.25781 1.81641C4.37891 1.88672 3.74609 1.95703 3.35938 2.09766C2.62109 2.37891 2.12891 2.90625 1.84766 3.60938C1.70703 3.99609 1.60156 4.62891 1.56641 5.50781C1.53125 6.03516 1.53125 6.77344 1.53125 7.6875V8.8125C1.53125 9.76172 1.53125 10.5 1.56641 10.9922C1.60156 11.8711 1.70703 12.5039 1.84766 12.8906C2.12891 13.6289 2.65625 14.1211 3.35938 14.4023C3.74609 14.543 4.37891 14.6484 5.25781 14.6836C5.75 14.7188 6.48828 14.7188 7.4375 14.7188H8.5625C9.51172 14.7188 10.25 14.7188 10.7422 14.6836C11.6211 14.6484 12.2539 14.543 12.6406 14.4023C13.3438 14.1211 13.8711 13.5938 14.1523 12.8906Z"
						/>
					</svg>
				</a>
				<a
					v-if="env.socialUrls.twitter"
					:href="env.socialUrls.twitter"
					target="_black"
					class="desktop-layout__bottom__desc__socials__link"
				>
					<svg
						width="18"
						height="16"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						class="desktop-layout__bottom__desc__socials__icon"
					>
						<path
							d="M15.2716 1.58655H18.0828L11.9411 8.60612L19.1663 18.1582H13.509L9.07804 12.3649L4.00796 18.1582H1.19503L7.7642 10.65L0.833008 1.58655H6.63393L10.6392 6.88182L15.2716 1.58655ZM14.2849 16.4755H15.8427L5.7875 3.18082H4.11589L14.2849 16.4755Z"
						/>
					</svg>
				</a>
				<a
					v-if="env.socialUrls.youtube"
					:href="env.socialUrls.youtube"
					target="_black"
					class="desktop-layout__bottom__desc__socials__link"
				>
					<svg
						width="21"
						height="14"
						viewBox="0 0 21 14"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						class="desktop-layout__bottom__desc__socials__icon"
					>
						<path
							d="M19.7109 2.60938C19.8516 3.24219 19.9922 4.22656 20.0625 5.49219L20.0977 7.25L20.0625 9.00781C19.9922 10.3438 19.8516 11.293 19.7109 11.9258C19.5703 12.3477 19.3594 12.6992 19.0781 12.9805C18.7617 13.2969 18.4102 13.5078 17.9883 13.6133C17.3555 13.7891 15.9492 13.8945 13.6992 13.9648L10.5 14L7.30078 13.9648C5.05078 13.8945 3.60938 13.7891 3.01172 13.6133C2.58984 13.5078 2.20312 13.2969 1.92188 12.9805C1.60547 12.6992 1.39453 12.3477 1.28906 11.9258C1.11328 11.293 1.00781 10.3438 0.9375 9.00781L0.902344 7.25C0.902344 6.75781 0.902344 6.16016 0.9375 5.49219C1.00781 4.22656 1.11328 3.24219 1.28906 2.60938C1.39453 2.1875 1.60547 1.83594 1.92188 1.51953C2.20312 1.23828 2.58984 1.02734 3.01172 0.886719C3.60938 0.746094 5.05078 0.605469 7.30078 0.535156L10.5 0.5L13.6992 0.535156C15.9492 0.605469 17.3555 0.746094 17.9883 0.886719C18.4102 1.02734 18.7617 1.23828 19.0781 1.51953C19.3594 1.83594 19.5703 2.1875 19.7109 2.60938ZM8.53125 10.1328L13.5586 7.25L8.53125 4.40234V10.1328Z"
						/>
					</svg>
				</a>
				<a
					v-if="env.socialUrls.linkedin"
					:href="env.socialUrls.linkedin"
					target="_black"
					class="desktop-layout__bottom__desc__socials__link"
				>
					<svg
						width="16"
						height="17"
						viewBox="0 0 16 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						class="desktop-layout__bottom__desc__socials__icon"
					>
						<path
							d="M14.75 0.375C15.0312 0.375 15.3125 0.515625 15.5234 0.726562C15.7344 0.9375 15.875 1.21875 15.875 1.5V15C15.875 15.3164 15.7344 15.5977 15.5234 15.8086C15.3125 16.0195 15.0312 16.125 14.75 16.125H1.25C0.933594 16.125 0.652344 16.0195 0.441406 15.8086C0.230469 15.5977 0.125 15.3164 0.125 15V1.5C0.125 1.21875 0.230469 0.9375 0.441406 0.726562C0.652344 0.515625 0.933594 0.375 1.25 0.375H14.75ZM4.87109 13.875H4.90625V6.35156H2.55078V13.875H4.87109ZM3.71094 5.33203C4.0625 5.33203 4.37891 5.22656 4.66016 4.94531C4.94141 4.66406 5.08203 4.34766 5.08203 3.99609C5.08203 3.64453 4.94141 3.32812 4.66016 3.04688C4.37891 2.76562 4.0625 2.625 3.71094 2.625C3.32422 2.625 3.00781 2.76562 2.76172 3.04688C2.48047 3.32812 2.375 3.64453 2.375 3.99609C2.375 4.34766 2.48047 4.66406 2.76172 4.94531C3.00781 5.22656 3.32422 5.33203 3.71094 5.33203ZM13.625 13.875V9.76172C13.625 8.60156 13.4492 7.75781 13.1328 7.19531C12.6758 6.52734 11.9023 6.17578 10.8477 6.17578C10.2852 6.17578 9.82812 6.31641 9.40625 6.5625C9.05469 6.77344 8.77344 7.05469 8.63281 7.37109H8.59766V6.35156H6.34766V13.875H8.66797V10.1484C8.66797 9.58594 8.73828 9.12891 8.91406 8.8125C9.125 8.42578 9.51172 8.21484 10.0742 8.21484C10.6016 8.21484 10.9531 8.46094 11.1289 8.88281C11.2344 9.16406 11.3047 9.62109 11.3047 10.2188V13.875H13.625Z"
						/>
					</svg>
				</a>
				<a v-if="env.socialUrls.tiktok" :href="env.socialUrls.tiktok" target="_black"
					class="desktop-layout__bottom__desc__socials__link">
					<svg width="16" height="15" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"
						class="desktop-layout__bottom__desc__socials__icon">
						<path
							d="M10 0C11.1046 0 12 0.89543 12 2C12 3.44733 13.03 4.6618 14.3984 4.93991C15.4808 5.15992 16.1799 6.21575 15.9599 7.29819C15.7399 8.3806 14.6841 9.0798 13.6016 8.8598C13.0406 8.7457 12.5037 8.5646 12 8.3252V14C12 17.3137 9.3137 20 6 20C2.68629 20 0 17.3137 0 14C0 11.2015 1.91407 8.8551 4.50148 8.1891C5.57119 7.91382 6.6616 8.5578 6.9369 9.6275C7.2122 10.6972 6.5682 11.7876 5.49852 12.0629C4.63547 12.285 4 13.0708 4 14C4 15.1046 4.89543 16 6 16C7.1046 16 8 15.1046 8 14V2C8 0.89543 8.8954 0 10 0Z" />
					</svg>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import Button from "../components/Shared/Button.vue";
import Logo from "../components/Shared/Logo.vue";

export default {
  components: { Logo, Button },
  computed: {
    emailLink() {
      const user = this.$store.getters.user;
      const user_agent = navigator.userAgent;
      const ip = this.$store.getters["dataNotifier/userinfo"]
        ? this.$store.getters["dataNotifier/userinfo"].ip
        : "n/a";
      const env = this.env;
      const payload = {
        subject: encodeURIComponent("Hello Betika Customer Support"),
        body: encodeURIComponent(`
					Customer Details:
					Phone Number: ${user.mobile || "N/A (Logged Out)"},
					User Agent: ${user_agent},
					IP: ${ip},
					Country: ${env.country}

					Issue Description:

					**Type your issue here**
				`),
      };

      const supportEmail = this.env.supportEmail;

      return (
        "mailto:" +
				`${supportEmail}?` +
				Object.keys(payload).reduce((acc, curr) => {
				  if (acc == "") return `${curr}=${payload[curr]}`;
				  return `${acc}&${curr}=${payload[curr]}`;
				}, "")
      );
    },
	isKenya() {
			return this.env.country === 'KENYA';
		}
  },
};
</script>

<style lang="scss">
.desktop-layout {
	&__bottom {
		background: var(--white);
		padding: 60px;
		&__divider {
			border: 1px solid var(--main-bg-color);
			margin: 40px auto;
			display: block;
		}
		&__desc {
			width: 95%;
			margin: 0 auto;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			&__copyright {
				font-weight: var(--font-weight-lighter);
				color: var(--light-black);
				margin: 0;
			}
			&__regulator {
				font-weight: var(--font-weight-lighter);
				color: var(--light-black);
				margin: 0;
			}
			&__socials {
				display: flex;
				flex-direction: row;
				align-items: center;
				&__logo {
					width: 24px;
					height: 24px;
				}
				&__link {
					text-decoration: none;
					margin-right: 10px;
				}
				&__icon {
					fill: var(--light-black);
				}
			}
		}
	}
	&__footer {
		&__top {
			display: flex;
			align-items: flex-start;
			justify-content: space-around;
			width: 60%;
			margin: 0 auto;
			&__logo {
				padding: 10px 20px;
			}
		}
		&__column {
			margin-right: 20px;
			&__title {
				margin: 0;
				font-size: var(--font-large);
				font-weight: var(--font-weight-medium);
				margin-bottom: 20px;
				color: var(--black);
			}
			&__links {
				margin: 0;
				list-style: none;
				padding: 0;
				&__item {
					margin-bottom: 10px;
				}
			}
			&__link {
				text-decoration: none;
				font-weight: var(--font-weight-lighter);
				color: var(--light-black);
			}
		}
		&__contacts {
		}
		&__contact-icon {
			padding-right: 5px;
		}
		&__contact-with-icon {
			margin-bottom: 15px;
			display: flex;
			align-items: center;
		}
		&__contact {
			margin-bottom: 20px;
			&__label {
				color: var(--light-black);
				margin: 0;
				margin-bottom: 10px;
				font-weight: var(--font-weight-medium);
			}
			&__value {
				text-decoration: none;
				color: var(--light-black);
				margin: 0;
				font-weight: var(--font-weight-lighter);
				&--contact{
					font-weight: var(--font-weight-lighter);
					margin-left: 15px;
					margin-bottom: 10px;
					span{
						font-weight: 500;
					}
				}
				&--contact-availability{
						font-weight: var(--font-weight-lighter);
						color: var(--light-black)
				}
			}
		}
		&__divider {
			border: 1px solid var(--main-bg-color);
			width: 60%;
			margin: 40px auto;
			display: block;
		}
		&__bottom {
			width: 60%;
			margin: 0 auto;
			display: flex;
			flex-direction: row;
			&__item {
				margin-right: 40px;
				&__label {
					font-size: var(--font-large);
					font-weight: var(--font-weight-medium);
				}
				&__regulator {
					margin-right: 40px;
				}
				&__value {
					font-weight: var(--font-weight-lighter);
					color: var(--light-black);
					&__regulator {
						display: flex;
						font-weight: var(--font-weight-lighter);
						color: var(--light-black);
					}
				}
			}
		}
	}
}
</style>
